export const TagsListItem = {
  props: {
    item: Object,
    removeTag: Function,
    iconPath: Function,
  },
  template: `
    <label @click="removeTag(item)" :id="item.id" class="tag-item mr-2">
      <svg v-if="item.id === 'search-box'" aria-hidden="true" class="svg-size--1 svg-fill--dark mr-1"><use :href="iconPath('recherche')"></use>
      </svg>
      {{item.label}}
    </label>
  `
}